import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ModalState {
  isOpen: boolean;
  title?: string;
  content?: string;
}

interface UiState {
  sidebarCollapsed: boolean;
  mobileMenuOpen: boolean;
  globalModal: ModalState;
  breadcrumbs: { label: string; href?: string }[];
}

const initialState: UiState = {
  sidebarCollapsed: false,
  mobileMenuOpen: false,
  globalModal: { isOpen: false },
  breadcrumbs: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    },
    toggleSidebarCollapsed: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    toggleMobileMenu: (state) => {
      state.mobileMenuOpen = !state.mobileMenuOpen;
    },
    setMobileMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.mobileMenuOpen = action.payload;
    },
    openModal: (
      state,
      action: PayloadAction<{ title?: string; content?: string }>,
    ) => {
      state.globalModal = { isOpen: true, ...action.payload };
    },
    closeModal: (state) => {
      state.globalModal = { isOpen: false };
    },
    setBreadcrumbs: (
      state,
      action: PayloadAction<{ label: string; href?: string }[]>,
    ) => {
      state.breadcrumbs = action.payload;
    },
  },
  selectors: {
    selectSidebarCollapsed: (state) => state.sidebarCollapsed,
    selectMobileMenuOpen: (state) => state.mobileMenuOpen,
    selectGlobalModal: (state) => state.globalModal,
    selectBreadcrumbs: (state) => state.breadcrumbs,
  },
});

export const {
  setSidebarCollapsed,
  toggleSidebarCollapsed,
  toggleMobileMenu,
  setMobileMenuOpen,
  openModal,
  closeModal,
  setBreadcrumbs,
} = uiSlice.actions;

export const {
  selectSidebarCollapsed,
  selectMobileMenuOpen,
  selectGlobalModal,
  selectBreadcrumbs,
} = uiSlice.selectors;

export default uiSlice.reducer;
